import { createPath, To } from 'history';

/**
 * Нормализовать путь
 *
 * @param path - Исходный путь
 * @returns Нормализованный путь
 */
const normalizePath = (path: string) =>
  path.startsWith('/') ? path : `/${path}`;

/**
 * Получить из пути "название модуля"
 *
 * @param path - Исходный путь
 * @returns Название модуля
 */
export const getBasename = (path: string) =>
  normalizePath(path).split('/')[1].split('?')[0].split('#')[0];

/**
 * Убрать "название модуля" из пути
 *
 * @param haystack - Исходный путь
 * @param basenames - Массив названий модулей
 * @returns Путь без названия модуля
 */
export const removeBasename = (haystack: string, basenames?: string[]) => {
  if (!basenames || basenames.length === 0) {
    return haystack;
  }

  const normalizedFirstBasename = normalizePath(basenames[0]);

  if (haystack.startsWith(normalizedFirstBasename)) {
    return haystack.replace(normalizedFirstBasename, '/').replace('//', '/');
  }

  return haystack;
};

/**
 * Создать URL объект из пути
 *
 * @param to - Путь в виде строки или объекта To (pathname, search, hash)
 *
 * @returns URL объект
 */
export const createURL = (to: To): URL => {
  let base = 'http://localhost';
  if (typeof window !== 'undefined') {
    base =
      window.location.origin !== 'null'
        ? window.location.origin
        : window.location.href;
  }

  let href = typeof to === 'string' ? to : createPath(to);
  href = href.replace(/ $/, '%20'); // Защита от краша, если в путь случайно попал trailing space.

  return new URL(href, base);
};
